<template>
    <section v-if="allPage" class="section section-lg pt-lg-0" style="margin-top: 150px !important;">
      <div class="container">
<hr>
        <div class="row justify-content-center text-center ">
          <div class="col-lg-6">

            <h1 class="display-3">
              Users
            </h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div @click="showUserQuestions(user.ID)" v-for="user in users" v-bind:key="user.Email" class="col-lg-4 mt-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="d-flex align-items-center">
                    <icon
                      name="ni ni-circle-08"
                      type="primary"
                      rounded
                    >
                    </icon>
                    <div>
                      <h6 class="text-primary text-uppercase mt-3 px-1">{{user["Name"]}}</h6>
                    </div>
                  </div>
                  <p class="description mt-3">
                    Email: {{user["Email"]}} <br>
                    Role: {{user["Role"]}} <br>
                    CurrentQuestion: {{user["CurrentQuestion"]}} <br>
                    Retries: {{user["Retries"]}} <br>
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
<hr>
        <div class="row justify-content-center text-center ">
          <div class="col-lg-6">

            <h1 class="display-3">
              User Questions (of selected user above)
            </h1>
          </div>
        </div>
        <div class="row justify-content-center text-center ">
          <base-button slot="button" @click="clearUserQuestions()" type="danger" size="lg" class="align-center">
            <div class="px-5">
              <i style="color: white" class="fa fa-check-circle"></i>
              <span class="btn-inner--text">Clear UQs of selected user</span>
            </div>
          </base-button >
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div v-for="userQuestion in userQuestionsToShow" v-bind:key="userQuestion.ID" class="col-lg-4 mt-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="d-flex align-items-center">
                    <icon
                      name="ni ni-bullet-list-67"
                      type="primary"
                      rounded
                    >
                    </icon>
                    <div>
                      <h6 class="text-primary text-uppercase mt-3 px-1">{{userQuestion["ID"]}}</h6>
                    </div>
                  </div>
                  <p class="description mt-3">
                    <b>Answer:</b> {{userQuestion["Answer"]}} <br>
                    <b>QuestionID:</b> {{userQuestion["QuestionID"]}} <br>
                    <b>UserID:</b> {{userQuestion["UserID"]}} <br>
                    <b>Question Body:</b> {{userQuestion["Question"]["Body"]}} <br>
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
<hr>
        <div class="row justify-content-center text-center ">
          <div class="col-lg-6">

            <h1 class="display-3">
              User Questions Logs (of selected user above)
            </h1>
          </div>
        </div>
        <div class="row justify-content-center text-center ">
          <base-button slot="button" @click="clearUserQuestions()" type="danger" size="lg" class="align-center">
            <div class="px-5">
              <i style="color: white" class="fa fa-check-circle"></i>
              <span class="btn-inner--text">Clear UQs of selected user</span>
            </div>
          </base-button >
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div v-for="userQuestion in userQuestionLogsToShow" v-bind:key="userQuestion.ID" class="col-lg-4 mt-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="d-flex align-items-center">
                    <icon
                      name="ni ni-bullet-list-67"
                      type="primary"
                      rounded
                    >
                    </icon>
                    <div>
                      <h6 class="text-primary text-uppercase mt-3 px-1">{{userQuestion["ID"]}}</h6>
                    </div>
                  </div>
                  <p class="description mt-3">
                    <b>Answer:</b> {{userQuestion["Answer"]}} <br>
                    <b>QuestionID:</b> {{userQuestion["QuestionID"]}} <br>
                    <b>UserID:</b> {{userQuestion["UserID"]}} <br>
                    <b>Question Body:</b> {{userQuestion["Question"]["Body"]}} <br>
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
<hr>
        <div class="row justify-content-center text-center ">
          <div class="col-lg-6">

            <h1 class="display-3">
              Questions
            </h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div v-for="question in questions" v-bind:key="question.ID" class="col-lg-4 mt-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="d-flex align-items-center">
                    <icon
                      name="ni ni-bullet-list-67"
                      type="primary"
                      rounded
                    >
                    </icon>
                    <div>
                      <h6 class="text-primary text-uppercase mt-3 px-1">{{question["ID"]}}</h6>
                    </div>
                  </div>
                  <p class="description mt-3">
                    <b>Answers:</b> {{question["Answers"]}} <br>
                    <b>Body:</b> {{question["Body"]}} <br>
                    <b>Code Block:</b> {{question["CodeBlock"]}} <br>
                    <b>Image URL:</b> {{question["ImageURL"]}} <br>
                    <b>Right Answer:</b> {{question["RightAnswer"]}} <br>
                    <b>Timeout:</b> {{question["Timeout"]}} <br>
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
<hr>
        <div class="row justify-content-center text-center ">
          <div class="col-lg-6">

            <h1 class="display-3">
              User Questions (all)
            </h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div v-for="userQuestion in userQuestions" v-bind:key="userQuestion.ID" class="col-lg-4 mt-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="d-flex align-items-center">
                    <icon
                      name="ni ni-bullet-list-67"
                      type="primary"
                      rounded
                    >
                    </icon>
                    <div>
                      <h6 class="text-primary text-uppercase mt-3 px-1">{{userQuestion["ID"]}}</h6>
                    </div>
                  </div>
                  <p class="description mt-3">
                    <b>Answer:</b> {{userQuestion["Answer"]}} <br>
                    <b>QuestionID:</b> {{userQuestion["QuestionID"]}} <br>
                    <b>UserID:</b> {{userQuestion["UserID"]}} <br>
                    <b>Question Body:</b> {{userQuestion["Question"]["Body"]}} <br>
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
<hr>
      </div>
    </section>
</template>

<script>
import router from '../router';
export default {
  data: () => ({
    allPage: false,
    users: [],
    questions: [],
    userQuestions: [],
    userQuestionsToShow: [],
    userQuestionLogsToShow: [],
  }),
  computed: {
  },
  methods: {
    showUserQuestions(id){
      const urlUserQuestionsByID = process.env.VUE_APP_API_URL + "/resource/user-question/" + id;
      const urlUserQuestionLogsByID = process.env.VUE_APP_API_URL + "/resource/user-question-log/" + id;
      fetch(urlUserQuestionsByID, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem('token')
      }}).then(res => res.json())
      .then(res => {
        this.userQuestionsToShow = res
      });

      fetch(urlUserQuestionLogsByID, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem('token')
      }}).then(res => res.json())
      .then(res => {
        this.userQuestionLogsToShow = res
        console.log(res)
      });

    },
    clearUserQuestions(){
      this.userQuestionsToShow = []
    }
  },
  created: async function () {
    console.log(process.env.VUE_APP_ALL_PAGE)
    if(process.env.VUE_APP_ALL_PAGE) { 
      this.allPage = true
      //const urlNext = process.env.VUE_APP_API_URL + "/resource/question-next";
      const urlUsers = process.env.VUE_APP_API_URL + "/auth/user";
      const urlQuestions = process.env.VUE_APP_API_URL + "/resource/question";
      const urlUserQuestions = process.env.VUE_APP_API_URL + "/resource/user-question";

      fetch(urlUsers, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem('token')
      }}).then(res => res.json())
      .then(res => {
        this.users = res;
      });

      fetch(urlQuestions, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem('token')
      }}).then(res => res.json())
      .then(res => {
        this.questions = res;
      });

      fetch(urlUserQuestions, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem('token')
      }}).then(res => res.json())
      .then(res => {
        this.userQuestions = res;
      });
    }
    else { 
      this.allPage = false
      router.push("/");
    }
  },
  components: {
  }
};
</script>
<style>

</style>

